export default __webpack_public_path__ + "static/creare-connessioni-importanza-network-350ca6ee5b2250aa2cd196ae77d9c284.jpg";